export enum AccountUpgradeLimitModalContext {
  DashpivotVisitorUsers = 'Dashpivot Visitor Users',
  SitematePaidUsers = 'Sitemate Paid Users',
  UnlockSSO = 'Unlock SSO',
  AdditionalWorkspaces = 'Additional Workspaces',
}
